import { fetchApi } from '../../../../lib/fetchApi';
import { SendEmailDto } from '../../generic/types';
import { UserFormDto, UserListFields, UserSelectorsDataDto } from '../types';
import { Pagination, PaginationFilterDto } from '../../../../types/Pagination';
import { DeleteReasonDto } from '../../../../types/DeleteReasonDto';

const BASE_URL: string = "/users";

export const getUsers = async (body: PaginationFilterDto): Promise<Pagination<UserListFields>> => {
    try{
        const response = await fetchApi.post(`${BASE_URL}`, body ) as Pagination<UserListFields>;
        return response;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const deleteLogicUser = async (userId: number, body: DeleteReasonDto): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/delete/${userId}`, body);
};
export const reactiveUser = async (userId: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/active/${userId}`);
};

export const restorePasswordEmailUser = async (body: SendEmailDto): Promise<void> => {
    await fetchApi.post(`/auth/sendEmail`,  body);
};

export const createUser = async (body: UserFormDto): Promise<UserFormDto> => {
    const response = await fetchApi.post(`${BASE_URL}/create`, body) as UserFormDto;
    return response;
}

export const getUserById = async (idUser: string): Promise<UserFormDto> => {
    const response = await fetchApi.get(`${BASE_URL}/${idUser}`) as UserFormDto;
    return response
};

export const updateUser = async (idUser: string, body: UserFormDto): Promise<UserFormDto> => {
    const response = await fetchApi.put(`${BASE_URL}/${idUser}`, body) as UserFormDto
    return response;
}

export const getSelectorsData = async (): Promise<UserSelectorsDataDto> => {
    const response = await fetchApi.get(`${BASE_URL}/selectors-data`) as UserSelectorsDataDto;
    return response;
}